import React from 'react';
import { LINKS } from '../lib/links';
import { WhatsAppIcon } from './WhatsAppButton';
export function StickyCTA() {
  return <>
      {/* Mobile Sticky Bottom Bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-cream/95 backdrop-blur-md border-t border-pine/10 p-3" data-id="element-212">
        <div className="flex gap-2 max-w-md mx-auto" data-id="element-213">
          <a href={LINKS.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="Message Zev on WhatsApp" className="flex-1 inline-flex items-center justify-center gap-2 bg-whatsapp text-white py-3.5 px-3 rounded-sm font-medium text-sm tracking-wide active:scale-[0.98] transition-transform" data-id="element-214">
            <WhatsAppIcon className="w-4 h-4" data-id="element-215" />
            WhatsApp Zev
          </a>
          <a href="#stay" className="flex-1 inline-flex items-center justify-center gap-2 bg-cream border border-pine/25 text-pine py-3.5 px-3 rounded-sm font-medium text-sm tracking-wide active:scale-[0.98] transition-transform" data-id="element-216">
            Stay
          </a>
        </div>
      </div>

      {/* Desktop Floating Button */}
      <div className="hidden md:block fixed bottom-8 right-8 z-50" data-id="element-217">
        <a href={LINKS.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="Message Zev on WhatsApp" className="inline-flex items-center gap-2 bg-whatsapp text-white py-4 px-6 rounded-sm font-medium tracking-wide shadow-2xl hover:bg-whatsappDeep hover:scale-105 transition-all duration-300" data-id="element-218">
          <WhatsAppIcon className="w-5 h-5" data-id="element-219" />
          WhatsApp Zev
        </a>
      </div>
    </>;
}